<template>
  <div class="feed-block">
    <FeedBlockEmptySvg />
    <div class="content">
      <p>
        <strong>Encore rien ici… mais ça ne saurait tarder !</strong><br />

        Tes progrès, les actus de tes potes et les dernières nouveautés
        arriveront bientôt. Reste connecté ! 🚀
      </p>
    </div>
    <p>En attendant, continue de progresser !</p>
    <ButtonBase
      stroke="n"
      class="button"
      theme="secondary"
      rounded
      size="small"
      to="/revisions"
      @click="handleAction"
    >
      Révisier
    </ButtonBase>
  </div>
</template>
<script setup lang="ts">
const dialog = useDialogStore();

const handleAction = async () => {
  dialog.close();
};
</script>
<style lang="scss" scoped>
.feed-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--gap_m);
  gap: var(--gap_m);
  text-align: center;

  /* Encore rien ici… mais ça ne saurait tarder ! Tes progrès, les actus de tes potes et les dernières nouveautés arriveront bientôt. Reste connecté ! 🚀 En attendant, continue de progresser ! */
  @include font('n', 600, 'secondary');
}
.title {
  @include font('l', 700, 'secondary');

  color: var(--color_neutral_800);
}
</style>
